import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import { Box, BoxProps, Typography, useTheme } from '@mui/material'

export function Avatar({
  variant = 'default',
  state = 'default',
  letters,
  src,
  ...props
}: {
  variant?: 'default' | 'small' | 'large' | 'largeDisplay'
  state?: 'default' | 'letter' | 'image'
  letters?: string
  src?: string
} & BoxProps) {
  const theme = useTheme()
  return (
    <Box
      width={
        variant === 'default'
          ? theme.size[10]
          : variant === 'small'
            ? theme.size[8]
            : variant === 'large'
              ? theme.size[12]
              : theme.size[19]
      }
      height={
        variant === 'default'
          ? theme.size[10]
          : variant === 'small'
            ? theme.size[8]
            : variant === 'large'
              ? theme.size[12]
              : theme.size[19]
      }
      bgcolor={theme.palette.primary.lightest}
      alignItems="center"
      justifyContent="center"
      display="flex"
      borderRadius={theme.radius.full}
      {...props}
    >
      {state === 'image' && src ? (
        <img
          src={src}
          alt="Avatar"
          style={{
            borderRadius: theme.radius.full,
            width: '100%',
            height: '100%',
          }}
        />
      ) : state === 'letter' && letters ? (
        <Typography variant={variant === 'default' ? 'body-small' : variant === 'small' ? 'caption' : 'h3'}>
          {letters}
        </Typography>
      ) : (
        <PersonOutlineOutlinedIcon
          sx={{
            color: theme.palette.primary.main,
            fontSize: variant === 'default' ? theme.size[7] : variant === 'small' ? theme.size[6] : theme.size[8],
          }}
        />
      )}
    </Box>
  )
}
